// Import Routes
import * as ROUTES from "../routes";

import PROFILE from '@/modules/settings/views/profile'
import CHANGEPASSWORD from '@/modules/settings/views/change-password'
import CHANGEPIN from '@/modules/settings/views/change-pin'

const routes = [
    {
        path: ROUTES.PROFILE,
        name: "Profile",
        component: PROFILE,
        meta: {
            title: "Dtunes Setting",
            layout: "private",
            requiresAuth: true,
            nav: 'Settings'
        }
    },
    {
        path: ROUTES.CHANGEPASSWORD,
        name: "Change Password",
        component: CHANGEPASSWORD,
        meta: {
            title: "Dtunes Setting",
            layout: "private",
            requiresAuth: true,
            nav: '  Settings'
        }
    },
    {
        path: ROUTES.CHANGEPIN,
        name: "Change Pin",
        component: CHANGEPIN,
        meta: {
            title: "Dtunes Setting",
            layout: "private",
            requiresAuth: true,
            nav: '  Settings'
        }
    }
]

export default routes;